import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d0ca48c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "my-collection",
  class: "search-result"
}
const _hoisted_2 = {
  key: 1,
  class: "search-result-body"
}
const _hoisted_3 = ["tabindex"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "mobile-mycollection-menu" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingView = _resolveComponent("LoadingView")!
  const _component_TheMyCollectionLeftColumn = _resolveComponent("TheMyCollectionLeftColumn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isProcessing)
      ? (_openBlock(), _createBlock(_component_LoadingView, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TheMyCollectionLeftColumn, { class: "search-result-side show-desktop" }),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), { class: "search-result-main" }))
        ])),
    _createElementVNode("div", {
      id: "modal-focus-target",
      tabindex: _ctx.showModal ? '0' : '-1'
    }, null, 8, _hoisted_3),
    _hoisted_4
  ]))
}